import { createPortal } from "react-dom";

export default function ConfirmModal({
  open,
  onClose,
  onConfirm,
  requestPayload,
  loading = false,
}) {
  if (!open) return null;

  return createPortal(
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-dialog-centered modal-md"
        role="document"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content shadow-lg rounded-4">

          {/* Header */}
          <div className="modal-header bg-primary text-white rounded-top-4">
            <h5 className="modal-title">Confirm Request</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
              disabled={loading}
            ></button>
          </div>

          {/* Body */}
          <div className="modal-body">
            <div className="alert alert-warning small">
              Please review your data carefully.  
              You will not be able to edit it again until the beginning of the next term.
            </div>

            <ul className="list-group list-group-flush mb-3">
              <li className="list-group-item">
                <strong>Field:</strong> {requestPayload.field}
              </li>
              <li className="list-group-item">
                <strong>New Value:</strong> {requestPayload.newValue}
              </li>
              <li className="list-group-item">
                <strong>Reason:</strong> {requestPayload.reason}
              </li>
            </ul>
          </div>

          {/* Footer */}
          <div className="modal-footer">
            <button
              className="btn btn-outline-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>

            <button
              className="btn btn-danger d-flex align-items-center gap-2"
              onClick={onConfirm}
              disabled={loading}
            >
              {loading && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                ></span>
              )}
              {loading ? "Submitting..." : "Confirm & Submit"}
            </button>
          </div>

        </div>
      </div>
    </div>,
    document.body
  );
}
